import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Review 3',
    id: 'WB4-V2-PV3-P66-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    padding: '0 0 0 5px',
    exerciseKey: 'img/FriendsPlus/Page66/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page66/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page66/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page66/E1/3.jpg', input: true, answer: "shirt" },
        { url: 'img/FriendsPlus/Page66/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page66/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page66/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page66/E1/7.jpg', input: true, answer: "hat" },
        { url: 'img/FriendsPlus/Page66/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page66/E1/9.jpg', input: true, answer: "a scarf" },
        { url: 'img/FriendsPlus/Page66/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page66/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page66/E1/12.jpg', input: true, answer: "boots" },
        { url: 'img/FriendsPlus/Page66/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page66/E1/14.jpg', input: true, answer: "gloves" },
        { url: 'img/FriendsPlus/Page66/E1/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page66/E1/16.jpg' },
      ],
    ]
  },
  2: {
    unit: 'Review 3',
    id: 'WB4-V2-PV3-P66-E2',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    checkDuplicated: true,
    exerciseKey: 'img/FriendsPlus/Page66/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page66/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page66/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/3.jpg', input: true, answer: "store/fire station/school/airport" },
        { url: 'img/FriendsPlus/Page66/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/5.jpg', input: true, answer: "jeans/skirt/boots/scarf" },
        { url: 'img/FriendsPlus/Page66/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page66/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/8.jpg', input: true, answer: "raining/sunny/hot" },
        { url: 'img/FriendsPlus/Page66/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/10.jpg', input: true, answer: "store/fire station/school/airport" },
        { url: 'img/FriendsPlus/Page66/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/12.jpg', input: true, answer: "jeans/skirt/boots/scarf" },
        { url: 'img/FriendsPlus/Page66/E2/13.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page66/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/15.jpg', input: true, answer: "raining/sunny/hot" },
        { url: 'img/FriendsPlus/Page66/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/17.jpg', input: true, answer: "store/fire station/school/airport" },
        { url: 'img/FriendsPlus/Page66/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/19.jpg', input: true, answer: "jeans/skirt/boots/scarf" },
        { url: 'img/FriendsPlus/Page66/E2/20.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page66/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/22.jpg', input: true, answer: "raining/sunny/hot" },
        { url: 'img/FriendsPlus/Page66/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/24.jpg', input: true, answer: "store/fire station/school/airport" },
        { url: 'img/FriendsPlus/Page66/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/26.jpg', input: true, answer: "jeans/skirt/boots/scarf" },
        { url: 'img/FriendsPlus/Page66/E2/27.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page66/E2/28.jpg' },
      ],



    ]
  }
}
export default json;